"use strict";

var _toConsumableArray = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/classCallCheck");

var _inherits = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/Users/rishavanand/Projects/Exponents/virtooally-event/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var http_1 = __importDefault(require("http"));

var https_1 = __importDefault(require("https"));

var stream_1 = require("stream");

var httpLibs = {
  'http:': http_1.default,
  'https:': https_1.default
};
var redirectStatusCodes = new Set([301, 302, 303, 307, 308]);
var retryStatusCodes = new Set([429, 503]); // `request`, `response`, `abort`, left out, miniget will emit these.

var requestEvents = ['connect', 'continue', 'information', 'socket', 'timeout', 'upgrade'];
var responseEvents = ['aborted'];

Miniget.MinigetError = /*#__PURE__*/function (_Error) {
  _inherits(MinigetError, _Error);

  var _super = _createSuper(MinigetError);

  function MinigetError(message, statusCode) {
    var _this;

    _classCallCheck(this, MinigetError);

    _this = _super.call(this, message);
    _this.statusCode = statusCode;
    return _this;
  }

  return MinigetError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

Miniget.defaultOptions = {
  maxRedirects: 10,
  maxRetries: 2,
  maxReconnects: 0,
  backoff: {
    inc: 100,
    max: 10000
  }
};

function Miniget(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _a;

  var opts = Object.assign({}, Miniget.defaultOptions, options);
  var stream = new stream_1.PassThrough({
    highWaterMark: opts.highWaterMark
  });
  stream.destroyed = stream.aborted = false;
  var activeRequest;
  var activeResponse;
  var activeDecodedStream;
  var redirects = 0;
  var retries = 0;
  var retryTimeout;
  var reconnects = 0;
  var contentLength;
  var acceptRanges = false;
  var rangeStart = 0,
      rangeEnd;
  var downloaded = 0; // Check if this is a ranged request.

  if ((_a = opts.headers) === null || _a === void 0 ? void 0 : _a.Range) {
    var r = /bytes=(\d+)-(\d+)?/.exec("".concat(opts.headers.Range));

    if (r) {
      rangeStart = parseInt(r[1], 10);
      rangeEnd = parseInt(r[2], 10);
    }
  } // Add `Accept-Encoding` header.


  if (opts.acceptEncoding) {
    opts.headers = Object.assign({
      'Accept-Encoding': Object.keys(opts.acceptEncoding).join(', ')
    }, opts.headers);
  }

  var downloadHasStarted = function downloadHasStarted() {
    return activeDecodedStream && downloaded > 0;
  };

  var downloadComplete = function downloadComplete() {
    return !acceptRanges || downloaded === contentLength;
  };

  var reconnect = function reconnect(err) {
    activeDecodedStream = null;
    retries = 0;
    var inc = opts.backoff.inc;
    var ms = Math.min(inc, opts.backoff.max);
    retryTimeout = setTimeout(doDownload, ms);
    stream.emit('reconnect', reconnects, err);
  };

  var reconnectIfEndedEarly = function reconnectIfEndedEarly(err) {
    if (options.method !== 'HEAD' && !downloadComplete() && reconnects++ < opts.maxReconnects) {
      reconnect(err);
      return true;
    }

    return false;
  };

  var retryRequest = function retryRequest(retryOptions) {
    if (stream.destroyed) {
      return false;
    }

    if (downloadHasStarted()) {
      return reconnectIfEndedEarly(retryOptions.err);
    } else if ((!retryOptions.err || retryOptions.err.message === 'ENOTFOUND') && retries++ < opts.maxRetries) {
      var ms = retryOptions.retryAfter || Math.min(retries * opts.backoff.inc, opts.backoff.max);
      retryTimeout = setTimeout(doDownload, ms);
      stream.emit('retry', retries, retryOptions.err);
      return true;
    }

    return false;
  };

  var forwardEvents = function forwardEvents(ee, events) {
    var _iterator = _createForOfIteratorHelper(events),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var event = _step.value;
        ee.on(event, stream.emit.bind(stream, event));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  };

  var doDownload = function doDownload() {
    var parsed = {},
        httpLib;

    try {
      var urlObj = typeof url === 'string' ? new URL(url) : url;
      parsed = Object.assign({}, {
        host: urlObj.host,
        hostname: urlObj.hostname,
        path: urlObj.pathname + urlObj.search + urlObj.hash,
        port: urlObj.port,
        protocol: urlObj.protocol
      });

      if (urlObj.username) {
        parsed.auth = "".concat(urlObj.username, ":").concat(urlObj.password);
      }

      httpLib = httpLibs[String(parsed.protocol)];
    } catch (err) {// Let the error be caught by the if statement below.
    }

    if (!httpLib) {
      stream.emit('error', new Miniget.MinigetError("Invalid URL: ".concat(url)));
      return;
    }

    Object.assign(parsed, opts);

    if (acceptRanges && downloaded > 0) {
      var start = downloaded + rangeStart;
      var end = rangeEnd || '';
      parsed.headers = Object.assign({}, parsed.headers, {
        Range: "bytes=".concat(start, "-").concat(end)
      });
    }

    if (opts.transform) {
      try {
        parsed = opts.transform(parsed);
      } catch (err) {
        stream.emit('error', err);
        return;
      }

      if (!parsed || parsed.protocol) {
        httpLib = httpLibs[String(parsed === null || parsed === void 0 ? void 0 : parsed.protocol)];

        if (!httpLib) {
          stream.emit('error', new Miniget.MinigetError('Invalid URL object from `transform` function'));
          return;
        }
      }
    }

    var onError = function onError(err) {
      if (stream.destroyed || stream.readableEnded) {
        return;
      } // Needed for node v10.


      if (stream._readableState.ended) {
        return;
      }

      cleanup();

      if (!retryRequest({
        err: err
      })) {
        stream.emit('error', err);
      } else {
        activeRequest.removeListener('close', onRequestClose);
      }
    };

    var onRequestClose = function onRequestClose() {
      cleanup();
      retryRequest({});
    };

    var cleanup = function cleanup() {
      activeRequest.removeListener('close', onRequestClose);
      activeResponse === null || activeResponse === void 0 ? void 0 : activeResponse.removeListener('data', onData);
      activeDecodedStream === null || activeDecodedStream === void 0 ? void 0 : activeDecodedStream.removeListener('end', onEnd);
    };

    var onData = function onData(chunk) {
      downloaded += chunk.length;
    };

    var onEnd = function onEnd() {
      cleanup();

      if (!reconnectIfEndedEarly()) {
        stream.end();
      }
    };

    activeRequest = httpLib.request(parsed, function (res) {
      // Needed for node v10, v12.
      // istanbul ignore next
      if (stream.destroyed) {
        return;
      }

      if (redirectStatusCodes.has(res.statusCode)) {
        if (redirects++ >= opts.maxRedirects) {
          stream.emit('error', new Miniget.MinigetError('Too many redirects'));
        } else {
          if (res.headers.location) {
            url = res.headers.location;
          } else {
            var _err = new Miniget.MinigetError('Redirect status code given with no location', res.statusCode);

            stream.emit('error', _err);
            cleanup();
            return;
          }

          setTimeout(doDownload, parseInt(res.headers['retry-after'] || '0', 10) * 1000);
          stream.emit('redirect', url);
        }

        cleanup();
        return; // Check for rate limiting.
      } else if (retryStatusCodes.has(res.statusCode)) {
        if (!retryRequest({
          retryAfter: parseInt(res.headers['retry-after'] || '0', 10)
        })) {
          var _err2 = new Miniget.MinigetError("Status code: ".concat(res.statusCode), res.statusCode);

          stream.emit('error', _err2);
        }

        cleanup();
        return;
      } else if (res.statusCode && (res.statusCode < 200 || res.statusCode >= 400)) {
        var _err3 = new Miniget.MinigetError("Status code: ".concat(res.statusCode), res.statusCode);

        if (res.statusCode >= 500) {
          onError(_err3);
        } else {
          stream.emit('error', _err3);
        }

        cleanup();
        return;
      }

      activeDecodedStream = res;

      if (opts.acceptEncoding && res.headers['content-encoding']) {
        var _iterator2 = _createForOfIteratorHelper(res.headers['content-encoding'].split(', ').reverse()),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var enc = _step2.value;
            var fn = opts.acceptEncoding[enc];

            if (fn) {
              activeDecodedStream = activeDecodedStream.pipe(fn());
              activeDecodedStream.on('error', onError);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }

      if (!contentLength) {
        contentLength = parseInt("".concat(res.headers['content-length']), 10);
        acceptRanges = res.headers['accept-ranges'] === 'bytes' && contentLength > 0 && opts.maxReconnects > 0;
      }

      res.on('data', onData);
      activeDecodedStream.on('end', onEnd);
      activeDecodedStream.pipe(stream, {
        end: !acceptRanges
      });
      activeResponse = res;
      stream.emit('response', res);
      res.on('error', onError);
      forwardEvents(res, responseEvents);
    });
    activeRequest.on('error', onError);
    activeRequest.on('close', onRequestClose);
    forwardEvents(activeRequest, requestEvents);

    if (stream.destroyed) {
      streamDestroy.apply(void 0, _toConsumableArray(destroyArgs));
    }

    stream.emit('request', activeRequest);
    activeRequest.end();
  };

  stream.abort = function (err) {
    console.warn('`MinigetStream#abort()` has been deprecated in favor of `MinigetStream#destroy()`');
    stream.aborted = true;
    stream.emit('abort');
    stream.destroy(err);
  };

  var destroyArgs;

  var streamDestroy = function streamDestroy(err) {
    activeRequest.destroy(err);
    activeDecodedStream === null || activeDecodedStream === void 0 ? void 0 : activeDecodedStream.unpipe(stream);
    activeDecodedStream === null || activeDecodedStream === void 0 ? void 0 : activeDecodedStream.destroy();
    clearTimeout(retryTimeout);
  };

  stream._destroy = function () {
    stream.destroyed = true;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (activeRequest) {
      streamDestroy.apply(void 0, args);
    } else {
      destroyArgs = args;
    }
  };

  stream.text = function () {
    return new Promise(function (resolve, reject) {
      var body = '';
      stream.setEncoding('utf8');
      stream.on('data', function (chunk) {
        return body += chunk;
      });
      stream.on('end', function () {
        return resolve(body);
      });
      stream.on('error', reject);
    });
  };

  process.nextTick(doDownload);
  return stream;
}

module.exports = Miniget;